<template>
  <div class="full" v-show="skills.length != 0">
    <table class="table table-borderless">
      <thead>
        <tr class="font-weight-bold">
          <td class="center">HABILIDADES</td>
          <td class="center">AVALIE</td>
          <td class="center">MÉDIA</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="skill in skills" :key="skill.id" class="h-auto">
          <td>
            <span>{{ skill.name }}</span>
          </td>
          <td class="center">
            <div>
              <StarRating
                active-color="#9472F8"
                v-model="skill.current_rating"
                @rating-selected="ratingSave(skill)"
                :max-rating="5"
                :star-size="18"
                class="d-inline-block"
                :show-rating="false"
              ></StarRating>
            </div>
          </td>
          <td class="center">
            <StarRating
              active-color="#9472F8"
              v-model="skill.average"
              :read-only="true"
              d:max-rating="5"
              :star-size="18"
              class="d-inline-block"
              :show-rating="false"
            ></StarRating>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "axios";
import SkillRatingDetails from "./SkillRatingDetails.vue";
import StarRating from "vue-star-rating";

export default {
  props: [
    "job_id",
    "candidate_id",
    "apply_id",
    "shortlist_uid",
    "recruiter_id",
  ],
  components: { StarRating },
  mounted() {
    this.setSkills();
  },
  data: (_) => ({
    rating: 5,
    skills: [],
  }),
  watch: {
    candidate_id: function (next, old) {
      this.setSkills();
    },
  },
  computed: {
    makeURL() {
      let urls = {
        get: `/recruiters/candidate_skill_ratings/${this.job_id}/${this.candidate_id}/${this.apply_id}`,
        post: `/recruiters/candidate_skill_ratings/${this.candidate_id}/${this.apply_id}`,
      };
      let shortlist_uid = `?shortlist_uid=${this.shortlist_uid}`;

      if (this.shortlist_uid) {
        urls.get += shortlist_uid;
        urls.post += shortlist_uid;
      }

      return urls;
    },
  },
  methods: {
    add_uid(url) {
      if (top.location.href.indexOf("?account_uid=") > -1) {
        let account_uid = top.location.href.slice(
          top.location.href.indexOf("?account_uid=") + 13
        );
        url += `&account_uid=${account_uid}`;
      }

      return url;
    },
    async setSkills() {
      axios.get(this.add_uid(this.makeURL.get)).then((response) => {
        let job_skills = response.data.job_skills;
        this.skills = [];
        for (let index in job_skills) {
          this.skills.push({
            id: job_skills[index].id,
            skill_id: job_skills[index].skill_id,
            candidate_skill_id: 0,
            average: 0,
            name: job_skills[index].name,
            current_rating: 0,
          });

          for (let rating of response.data.candidate_skills) {
            if (rating.skill_id != job_skills[index].skill_id) continue;
            this.skills[index].average = rating.average;
            this.skills[index].candidate_skill_id = rating.candidate_skill_id;
          }
        }
      });
    },
    ratingSave(skill) {
      let candidate_skill_ratings = {
        skill_id: skill.skill_id,
        rating: skill.current_rating,
        apply_id: this.apply_id,
        recruiter_id: this.recruiter_id,
      };
      axios
        .post(this.add_uid(this.makeURL.post), {
          candidate_skill_ratings,
        })
        .then((response) => {
          if (response.status) {
            this.$toast.success("Avaliação feita com sucesso!");
            this.setSkills();
          } else this.$toast.success("Não foi possivel realizar a avaliação");
        });
    },
    openDetails() {
      this.$modal.show(
        SkillRatingDetails,
        {
          apply_id: this.apply_id,
        },
        {
          width: "50%",
          height: "auto",
          scrollable: true,
        }
      );
    },
  },
};
</script>